// 繁体中文
export default {
  'SLModal.default.okText': '完成',
  'SLModal.default.cacelText': '取消',
  'SLModal.info.okText': '我知道了',
  'SLPopconfirm.cancelText': '取消',
  'SLPopconfirm.okText': '確定',
  'SLModal.danger.okText': '刪除',
  'SLUpload.default.image.addImage': '添加圖片',
  'SLUpload.default.image.restImages': '查看剩餘{{len}}張圖片',
  'SLUpload.default.image.loading': '上傳中...',
  'SLUpload.default.image.fail': '上傳失敗，請重試',
  'SLUpload.default.image.delete.title': '確認要刪除嗎？',
  'SLUpload.default.image.delete.content': '刪除後不可恢復。',
  'SLUpload.ALTFormModal.placeholder': '請輸入圖片ALT屬性',
  'SLUpload.ALTFormModal.tip': '編輯圖片ALT屬性有助搜索引擎優化(SEO)和視障人士體驗。',
  'SLUpload.ALTFormModal.title': '編輯圖片ALT屬性',
  'SLUpload.ALTFormModal.length': '最大不能超過{{max}}個字符',
  'SLUpload.uploadfile.fail': '上傳失敗',
  'SLUpload.uploadfile.fail1': '文件格式錯誤',
  'SLUpload.uploadfile.sucess': '上傳成功',
  'SLUpload.uploadfile.text1': '上傳文件',
  'SLUpload.uploadfile.text2': '僅支持.xlsx .xls.csv格式',
  'SLUpload.uploadfile.progress': '上傳中..',
  'SLUpload.dragUploading': '鬆開鼠標上傳',
  'SLUpload.default.image.description': '建議尺寸256 x 116',
  'SLUpload.default.image.fail.title': '{{fileName}} 上傳失敗',
  'SLUpload.default.image.fail.desc1': '大小不能超過{{max}}MB',
  'SLUpload.default.image.fail.desc2': '上傳名稱不能超過{{max}}個字數',
  'SLUpload.default.image.fail.desc3': '文件超出了最大分辨率{{limitPx}}MP。請縮減分辨率，然後重試',
  'SLUpload.default.image.fail.desc4': '抱歉！最多只能上傳{{maxNum}}張圖片！',
  'SLUpload.uploadField.errorMsg4': '上傳圖片失敗',
  'SLUpload.uploadField.upload': '上傳圖片',
  'SLUpload.SLImage.preview.closeText': '關閉'
};